import { z } from "zod";

const environmentSchema = z.object({
  VITE_APP_ENV: z.enum(["local", "preview", "production"]),
  VITE_SUPABASE_URL: z.url(),
  VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(8),
  VITE_EXPECTED_SUPABASE_REF: z.string().min(1),
  VITE_DEFAULT_LOCALE: z.enum(["ar", "en"]).default("ar"),
  VITE_DISPLAY_TIMEZONE: z.literal("Asia/Riyadh").default("Asia/Riyadh"),
});

const runtimeEnvironment = import.meta.env as unknown as Record<string, string | undefined>;

const candidate = {
  VITE_APP_ENV: runtimeEnvironment.VITE_APP_ENV,
  VITE_SUPABASE_URL: runtimeEnvironment.VITE_SUPABASE_URL,
  VITE_SUPABASE_PUBLISHABLE_KEY: runtimeEnvironment.VITE_SUPABASE_PUBLISHABLE_KEY,
  VITE_EXPECTED_SUPABASE_REF: runtimeEnvironment.VITE_EXPECTED_SUPABASE_REF,
  VITE_DEFAULT_LOCALE: runtimeEnvironment.VITE_DEFAULT_LOCALE,
  VITE_DISPLAY_TIMEZONE: runtimeEnvironment.VITE_DISPLAY_TIMEZONE,
};

const parsed = environmentSchema.safeParse(candidate);

if (!parsed.success && import.meta.env.MODE !== "test") {
  throw new Error(`Invalid public environment configuration: ${parsed.error.message}`);
}

export const environment = parsed.success
  ? parsed.data
  : environmentSchema.parse({
      VITE_APP_ENV: "local",
      VITE_SUPABASE_URL: "http://127.0.0.1:54321",
      VITE_SUPABASE_PUBLISHABLE_KEY: "local-test-key",
      VITE_EXPECTED_SUPABASE_REF: "local",
      VITE_DEFAULT_LOCALE: "ar",
      VITE_DISPLAY_TIMEZONE: "Asia/Riyadh",
    });
